export const WRONG_PLATFORM_CODE = 'WRONG_PLATFORM';

export const DEFAULT_REDIRECT_SECONDS = 5;
